import Pill from '@pelckmans/elementis/components/pill';
import TasksIcon from '@pelckmans/elementis/icons/tasks';
import UserIcon from '@pelckmans/elementis/icons/user';
import { ComponentProps, useMemo } from 'react';
import { Medialink } from '../../../../../api/medialink';
import { Module } from '../../../../../api/module';
import { MedialinkDialogHeaderTagsWithoutPillGroup } from '../../../../../pages/material/components/MedialinkDialogHeaderTags';
import { assignmentsEndIn24hours, assignmentsEndIn7Days } from '../../../../../pages/material/utils/assignmentUtils';
import { formatAssignmentToDate } from '../../../../../utils/formatDate';

interface Props {
  module: Module;
  medialink: Medialink;
  translations: {
    assignmentPill: string;
    deadlinePill: string;
  };
}

export default function ExerciseHighlightedItemTags({ module, medialink, translations }: Props) {
  const medialinkAssignment = medialink.assignments.find(assignment => 'current' in assignment);

  const pillProminence: ComponentProps<typeof Pill>['prominence'] = useMemo(() => {
    if (!medialinkAssignment) return undefined;

    if (assignmentsEndIn24hours(medialinkAssignment)) {
      return 'danger';
    } else if (assignmentsEndIn7Days(medialinkAssignment)) {
      return 'warning';
    }

    return 'neutral';
  }, [medialinkAssignment]);

  return (
    <>
      <MedialinkDialogHeaderTagsWithoutPillGroup module={module} material={medialink} />
      {medialinkAssignment && (
        <>
          <Pill key="assignment-pill" icon={<TasksIcon data-testid="tasks-icon" />}>
            {translations.assignmentPill}
          </Pill>
          <Pill key="deadline-pill" prominence={pillProminence}>{`${translations.deadlinePill} ${formatAssignmentToDate(
            medialinkAssignment.to,
          )}`}</Pill>
          {medialinkAssignment.user && (
            <Pill
              key="user-pill"
              icon={<UserIcon data-testid="user-icon" />}
            >{`${medialinkAssignment.user.firstName} ${medialinkAssignment.user.lastName}`}</Pill>
          )}
        </>
      )}
    </>
  );
}
